export default __webpack_public_path__ + "static/media/dental_at_center.471f0b58.svg";